function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "className", "lineHeight", "component", "minor", "isButton"],
  _excluded2 = ["children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import classNamesMaker from "classnames";
import { linkTypes } from "./types";
import { linkDefaultProps } from "./defaultProps";
import styles from "./link.module.css";
export var LINKS_LINE_HEIGHTS = {
  EDITO: "edito",
  NORMAL: "normal",
  SMALL: "small",
  MINOR: "minor"
};
export var Link = function Link(_ref) {
  var children = _ref.children,
    className = _ref.className,
    lineHeight = _ref.lineHeight,
    Component = _ref.component,
    minor = _ref.minor,
    isButton = _ref.isButton,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var withLineHeight = Object.values(LINKS_LINE_HEIGHTS).includes(lineHeight);
  var customClassNames = classNamesMaker(styles["jds-Link"], _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles["jds-Link--button"], isButton), styles["jds-Link--minor"], minor), styles["jds-Link--line-height-minor"], minor), styles["jds-Link--line-height-".concat(lineHeight)], withLineHeight), className);
  var manageRelAttr = function manageRelAttr(_ref2) {
    var rel = _ref2.rel,
      target = _ref2.target;
    var value = "".concat(rel || "", " ").concat(target ? "noopener noreferrer" : "").trim();
    return value ? {
      rel: value
    } : null;
  };
  var manageRoleAttr = function manageRoleAttr() {
    return isButton ? {
      role: "button",
      tabIndex: 0
    } : null;
  };
  var LinkComponent = isButton ? function (_ref3) {
    var buttonChildren = _ref3.children,
      buttonProps = _objectWithoutProperties(_ref3, _excluded2);
    return /*#__PURE__*/React.createElement("div", buttonProps, buttonChildren);
  } : Component;
  return /*#__PURE__*/React.createElement(LinkComponent, _extends({
    className: customClassNames
  }, restProps, manageRelAttr(restProps), manageRoleAttr()), children);
};
Link.propTypes = linkTypes;
Link.defaultProps = linkDefaultProps;